import React, { useContext, useEffect, useRef, useState } from "react";
import PageTitle from "../../Components/PageTitle";
import axios from "axios";
import { ConfigContext } from "../../Context/ConfigContext";
import { NoRecords } from "../../Components/Shimmer";
import { formatDate } from "../../Components/InputElements";
import { currentDateAndTime, formatDateWithTime, monthData } from '../../Constants/constants';
import Swal from 'sweetalert2';
import * as XLSX from 'xlsx';
import { decodeData } from "../../Constants/constants";
import { useLocation } from "react-router-dom";

function PayrollOtherHeadImport() {
    const { apiURL, apiHeaderFile, apiHeaderJSON,permissions,setPermissions } = useContext(ConfigContext);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const encodedData = queryParams.get("abs");
    const decodedData = encodedData ? decodeData(encodedData,permissions) : [];
   
    const [loading, setLoading] = useState(false);
    const [loadingDownload, setLoadingDownload] = useState(false);
    const [loadingDelete, setLoadingDelete] = useState(false);
    const [loadingImportExcel, setLoadingImportExcel] = useState(false);
    const [rows, setRows] = useState([]);
    const [onboardingResponse, setOnboardingResponse] = useState({});
    const [allSheetChecked, setAllSheetChecked] = useState(false);
    const [successMsg, setSuccessMsg] = useState(false);
    const [errorMsg, setErrorMsg] = useState(false);
    const [totalRecords, setTotalRecords] = useState(0);
    const [allPages, setAllPages] = useState(0);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [uploadSheets, setUploadSheet] = useState({
        file: null,
        remarks: "",
    });
    const limitOptions = [10, 25, 50, 100, 200, 500];
    const [pagination, setPagination] = useState({
            next: false,
            prev: false,
            page: 1,
            total_records: "",
            total_pages: "",
            limit: 10,
        });
    const [ischanged, setIschanged] = useState(false);
    const fileInputRef = useRef(null);

    // const downloadButton = async (id, excelName) => {
    //     setLoadingDownload(id);
    //     try {
    //         const response = await fetch(`${apiURL}Employees/DownloadOnboardExcel/${id}`, {
    //             headers: apiHeaderJSON,
    //         });
    //         console.log("=======>>>>", response);
    //         // Check if the response is okay
    //         if (!response.ok) {
    //             throw new Error('Network response was not ok');
    //         }

    //         const blob = await response.blob();
    //         const url = window.URL.createObjectURL(blob);
    //         const link = document.createElement('a');
    //         link.href = url;
    //         link.setAttribute('download', `excel.xlsx`); // Filename for the downloaded file
    //         document.body.appendChild(link);
    //         link.click();
    //         document.body.removeChild(link);
    //         setSuccessMsg("Excel Downloaded Successfully!!");
    //         setLoadingDownload(false);
    //         // Clean up the URL object
    //         window.URL.revokeObjectURL(url);
    //     } catch (error) {
    //         console.error('Error exporting jobs:', error);
    //         setLoadingDownload(false);
    //         setErrorMsg("There was a problem with the download!! Please try again later.");
    //     }
    // }
    const downloadButton = async (id, excelName) => {
        setLoadingDownload(id);
        try {
            const response = await fetch(`${apiURL}Payrolls/DownloadEmployeesOtherHeadsImportExcel/${id}`, {
                headers: apiHeaderJSON,
            });

            // Check if the response is okay
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            // Extract the filename from the Content-Disposition header
            const contentDisposition = response.headers.get('Content-Disposition');
            let fileName = excelName || 'default.xlsx'; // Use provided excelName or default filename

            if (contentDisposition) {
                const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
                if (fileNameMatch && fileNameMatch[1]) {
                    fileName = fileNameMatch[1]; // Extract the filename
                }
            }

            // Create a blob and download the file
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName); // Use the extracted filename
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setSuccessMsg("Excel Downloaded Successfully!!");
            setLoadingDownload(false);

            // Clean up the URL object
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error exporting jobs:', error);
            setLoadingDownload(false);
            setErrorMsg("There was a problem with the download!! Please try again later.");
        }
    }


    const getList = () => {

        let options = {
            url: `${apiURL}Payrolls/GetEmployeesOtherHeadsImportExcel?limit=${pagination?.limit}&page=${pagination?.page}`,
            method: "GET",
            headers: apiHeaderJSON,
        }
        axios(options)
            .then((response) => {
                // console.log("getList ~ response", response?.data);
                let res = response?.data;
                if (response.data.success === true) {
                    console.log("getList ~ res", res);
                    setRows(res?.data);
                    setOnboardingResponse(res);
                    setPagination({
                        next: res?.next || false,
                        prev: res?.prev || false,
                        page: res?.page || 1,
                        total_records: res?.total_records,
                        total_pages: res?.total_pages,
                        limit: res?.limit || 10,
                    })
                    // setSuccessMsg(response?.data?.message);
                    console.log("pagination?.limit",pagination?.limit);
                }
                else if (response.data.success === false) {
                    setErrorMsg(response?.data?.message);
                }
                setLoading(false);
            })
            .catch((e) => {
             setLoading(false);
                console.log(e);
                setErrorMsg(e?.data?.message);

            });

    }
    useEffect(() => {
        setLoading(true);
        getList();
       
    }, []);
    useEffect(() => {
        if(ischanged){
            getList();
            setIschanged(false)
        } 
    }, [ischanged]);

    const handleDeleteExcel = (id) => {
          const currentDate = currentDateAndTime();
        let options = {
            url: `${apiURL}Payrolls/DeleteEmployeesOtherHeadsImportExcel/${id}`,
            method: "DELETE",
            headers: apiHeaderJSON,
            data:{
                date:currentDate
            }
        }
        Swal.fire({
            title: 'Are you sure?',
            text: "Once deleted, you will not be able to recover this item!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, cancel!',
            allowOutsideClick:false,
        }).then((result) => {
            setLoadingDelete(id);
            if (result.isConfirmed) {
                axios(options)
                    .then((response) => {
                        // console.log("getList ~ response", response?.data);
                        let res = response?.data;
                        if (response.data.success === true) {
                            // console.log("handleDeleteExcel ~ res", res);
                            setSuccessMsg("Excel Deleted Successfully!!");
                            getList();
                        }
                        else if (response.data.success === false) {
                            setErrorMsg(response?.data?.message);
                        }

                        setLoadingDelete(false);
                    })
                    .catch((e) => {
                        console.log(e);
                        setErrorMsg(e?.data?.message);
                        setLoadingDelete(false);
                    });
            }
            setLoadingDelete(false);
        });

    }

    // const handleExcelDownload = async () => {
    //     const headers = apiHeaderJSON;
    //     let data = {
    //         ...uploadSheets
    //     }
    //     Swal.fire({
    //         title: 'Please wait...',
    //         html: 'Your file is being prepared for download.',
    //         allowOutsideClick: false,
    //         didOpen: () => {
    //             Swal.showLoading();
    //         }
    //     });

    //     axios.post(`${apiURL}Payrolls/GetSalaryHeadTemplate`, data, {
    //         headers
    //     })
    //         .then(async (response) => {
    //             const { success, Onboarding_template, message } = response.data;

    //             if (success === true) {
    //                 // Create a new workbook
    //                 const workbook = XLSX.utils.book_new();

    //                 // Function to create worksheet for a category
    //                 const createWorksheet = (headerArray, sheetName) => {
    //                     let worksheetArray = [headerArray];
    //                     const worksheet = XLSX.utils.aoa_to_sheet(worksheetArray);
    //                     XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    //                 };
    //                 // Basic Details Sheet
    //                 if (Onboarding_template.basicDetailsTemplateArray) {

    //                     createWorksheet(Onboarding_template.basicDetailsTemplateArray, 'basicDetails');
    //                 }
    //                 // Education Details Sheet
    //                 if (Onboarding_template.educationDetailsTemplateArray) {

    //                     createWorksheet(Onboarding_template.educationDetailsTemplateArray, 'educationDetails');
    //                 }
    //                 // Salary Details Sheet
    //                 if (Onboarding_template.SalaryDetailsTemplateArray) {

    //                     createWorksheet(Onboarding_template.SalaryDetailsTemplateArray, 'salaryDetails');
    //                 }
    //                 // Salary Details Sheet
    //                 if (Onboarding_template.StatutoryDetailsTemplateArray) {

    //                     createWorksheet(Onboarding_template.StatutoryDetailsTemplateArray, 'StatutoryDetails');
    //                 }

    //                 const date = new Date();
    //                 const dateString = date.toLocaleDateString();
    //                 const timeString = date.toLocaleTimeString();
    //                 const file_name = `Employee Onboard Excel_(${formatDate(dateString)}).xlsx`;
    //                 // Write the workbook to an Excel file
    //                 XLSX.writeFile(workbook, file_name);
    //                 // XLSX.writeFile(wb, `Employee Onboard Excel_(${formatDate(dateString)}).xlsx`);

    //                 Swal.close();
    //                 Swal.fire({
    //                     title: `<strong>Success</strong>`,
    //                     text: message,
    //                     icon: 'success',
    //                     showConfirmButton: true
    //                 });
    //             } else {
    //                 Swal.close();
    //                 Swal.fire({
    //                     title: `<strong>Failed</strong>`,
    //                     text: message,
    //                     icon: 'error',
    //                     showConfirmButton: true
    //                 });
    //             }
    //         })
    //         .catch((error) => {
    //             Swal.close();
    //             Swal.fire({
    //                 title: `<strong>Failed</strong>`,
    //                 text: error.response ? error.response.message : error.message,
    //                 icon: 'error',
    //                 showConfirmButton: true
    //             });
    //         });
    // }
    const handleExcelDownload = async () => {
        const headers = apiHeaderJSON;
        Swal.fire({
            title: 'Please wait...',
            html: 'Your file is being prepared for download.',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            }
        });
        
        axios.get(`${apiURL}Payrolls/GetOtherHeadsTemplate`, {
            headers
        , params:{date: currentDateAndTime()}
        })
            .then(async (response) => {
                const { success, PayrollOtherHeadsTemplateArray, message } = response.data;

                if (success === true) {
                    // Create a new workbook
                    const workbook = XLSX.utils.book_new();

                    // Function to create worksheet for a category
                    const createWorksheet = (dataArray, sheetName) => {
                        let worksheetArray = [];

                        // If it's a 2D array, map each sub-array
                        if (Array.isArray(dataArray[0])) {
                            dataArray.forEach(subArray => {
                                worksheetArray.push(subArray);
                            });
                        } else {
                            // Otherwise, just use the single array
                            worksheetArray.push(dataArray);
                        }

                        const worksheet = XLSX.utils.aoa_to_sheet(worksheetArray);
                        XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
                    };

                    // Payroll Other Heads Sheet
                    if (PayrollOtherHeadsTemplateArray) {
                        createWorksheet(PayrollOtherHeadsTemplateArray, 'PayrollOtherHeads');
                    }


                    const date = new Date();
                    const dateString = date.toLocaleDateString();
                    const file_name = `Payroll Other Heads Template.xlsx`;

                    // Write the workbook to an Excel file
                    XLSX.writeFile(workbook, file_name);

                    Swal.close();
                    Swal.fire({
                        title: `<strong>Success</strong>`,
                        text: message,
                        icon: 'success',
                        showConfirmButton: true
                    });
                } else {
                    Swal.close();
                    Swal.fire({
                        title: `<strong>Failed</strong>`,
                        text: message,
                        icon: 'error',
                        showConfirmButton: true
                    });
                }
            })
            .catch((error) => {
                Swal.close();
                Swal.fire({
                    title: `<strong>Failed</strong>`,
                    text: error.response ? error.response.message : error.message,
                    icon: 'error',
                    showConfirmButton: true
                });
            });
    };


    function uploadFile() {
        setLoadingImportExcel(true);
        let data = {
            ...uploadSheets,
            date: currentDateAndTime(),
        }
        let header = {
            ...apiHeaderFile,
        }
        // console.log("=====>>>", data);
        console.log("uploadFile ~ data", data);
        const options = {
            url: `${apiURL}Payrolls/ImportOtherPayrollHeads`,
            method: "POST",
            headers: header,
            data: data,
        }
        axios(options)
            .then((response) => {
                console.log("=======>>>>>response", response);
                if (response?.data?.success === true) {
                    setSuccessMsg(response?.data?.message);
                    getList();
                    // setAllSheetChecked(false);
                    setUploadSheet({
                        file: null,
                        remarks: "",
                    });
                    if (fileInputRef.current) {
                        fileInputRef.current.value = ''; 
                      }
                }
                else if (response?.data?.success === false) {
                    setErrorMsg(response?.data?.message || "There is a problem to upload excel!!");
                }

                setLoadingImportExcel(false);
            })
            .catch((e) => {
                console.log(e);
                setLoadingImportExcel(false);
            });
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        if (uploadSheets.file

        ) {
            uploadFile();

        }
        else if (
            !uploadSheets.file
        ) {
            setErrorMsg("Please select excel file to upload data.");
        }
    }

    const handlePrev = () => {
        console.log(pagination?.prev)
        if (pagination?.prev === true) {
            console.log(pagination?.page - 1)
            setPagination({
                ...pagination,
                page: pagination?.page - 1,
            });
        }
        setIschanged(true);
    }
    const handleNext = () => {
        console.log(pagination?.next)
        if (pagination?.next === true) {
            console.log(pagination?.page + 1)
            setPagination({
                ...pagination,
                page: pagination?.page + 1,
            });
        }
        setIschanged(true);
    }

    const handleClearAll = () => {
        ;
    };

    const handleLimitChange = (e) => {
        console.log(e.target.value);
        setPagination(
            {
                ...pagination,
                limit: parseInt(e.target.value),
                page: 1,
            });
        setIschanged(true);
    };

    const handleChanged = (e) => {
        setPagination({
          ...pagination,
          page: parseInt(e.target.value),
        });
        setIschanged(true);
    }


    // console.log("success", successMsg);

    return (
        <section>
            {!loading ?
                <div class="main-content" >
                    <div class="page-content">
                        <div className="container-fluid">
                            <br />
                            <PageTitle title={`Payroll Other Head Import`} primary={`Home`} />

                            <div className="card">
                                <div className="card-body">
                                { decodedData?.includes(6) && ( 
                                    <div className="row">
                                        <div className="col-md-4">
                                            <label htmlFor="keyword">File Upload</label>
                                            <div className="input-group">
                                                <input type="file" ref={fileInputRef} onChange={(e) => { setUploadSheet({ ...uploadSheets, file: e.target.files[0] }) }} accept=".xlsx" className="form-control" name="fileUpload" aria-label="Recipient's username" aria-describedby="button-addon2" placeholder="File Upload" />

                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <label htmlFor="keyword">Remarks</label>
                                            <div className="input-group">
                                                <input type="text" value={uploadSheets?.remarks} onChange={(e) => { setUploadSheet({ ...uploadSheets, remarks: e.target.value }) }} className="form-control" name="remarks" aria-label="Recipient's username" aria-describedby="button-addon2" placeholder="Remarks" />

                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <label htmlFor="keyword">Upload</label>
                                            <div>
                                                {!loadingImportExcel ?
                                                    <button type="button" onClick={(e) => handleSubmit(e)} className={`btn btn-info btn-label waves-effect waves-light w-100 ${uploadSheets?.file ? "" : "disabled"}`}>
                                                        <i className="bx bx-cloud-upload label-icon align-middle fs-16 me-2" />Upload
                                                    </button> :
                                                    <button type="button" className={`btn btn-info btn-label waves-effect waves-light w-100`}>
                                                        <i className="bx bx-cloud-upload label-icon align-middle fs-16 me-2" />Loading...
                                                    </button>
                                                }
                                            </div>
                                        </div>
                                        <div style={{ width: "15%" }} className='col-md-2'>
                                            <div>
                                                <label>Export Template</label>
                                            </div>
                                            <button
                                                type="button"
                                                onClick={handleExcelDownload}
                                                disabled={loading}
                                                className={`btn noWrap btn-success btn-label waves-effect waves-light noWrap`}>
                                                <i className="ri-file-excel-line label-icon align-middle fs-16 me-2" />
                                                {!loading ? "Download" : "Loading..."}
                                            </button>
                                        </div>
                                    </div>)}
                                    {successMsg ?
                                        <div className=" position-relative alert alert-success mt-3" role="alert">
                                            {successMsg} <span onClick={() => { setSuccessMsg(false) }} style={{ right: "1rem", top: "0.3rem", cursor: "pointer", fontSize: "1.3rem" }} className=" position-absolute">x</span>
                                        </div>
                                        : null
                                    }
                                    {errorMsg ?
                                        <div className=" position-relative alert alert-danger mt-3" role="alert">
                                            {errorMsg} <span onClick={() => { setErrorMsg(false) }} style={{ right: "1rem", top: "0.3rem", cursor: "pointer", fontSize: "1.3rem" }} className=" position-absolute">x</span>
                                        </div> : null
                                    }
                                    <div className=" mt-3">
                                        <div style={{ "maxHeight": "65vh", "overflowY": "auto" }} >
                                            <table className="table table-borderless table-hover align-middle mb-0 table-bordered table-stripped position-relative" style={{ width: "100%" }}>
                                                <thead class="bg-primary text-light bg-gradient sticky-top z-1">
                                                    <tr>
                                                        <th >Sr.No.</th>
                                                        <th >Upload Date</th>
                                                        <th >File Name</th>
                                                        <th >Remarks</th>
                                                        { decodedData?.includes(4) && ( 
                                                        <th className=' text-center'>Action</th>)}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {Array.isArray(rows) && rows?.length >= 1 ?
                                                        <>
                                                            {rows?.map((val, index) => {
                                                                return (
                                                                    <tr key={val?.id}>
                                                                        <td>{index + 1}</td>
                                                                        <td className="noWrap">{val?.updated_date ? formatDateWithTime(val?.updated_date) : "--"} </td>
                                                                        <td onClick={(e) => {
                                                                            downloadButton(val?.id, val?.file_name?.split("/")[val?.file_name?.split("/").length - 1])
                                                                        }}
                                                                            className="" >
                                                                            {loadingDownload === val?.id ?
                                                                                <div className="text-center">
                                                                                    <div className="spinner-border text-primary" role="status">
                                                                                        <span className="visually-hidden">Loading...</span>
                                                                                    </div>
                                                                                </div> :
                                                                                <p className=" hoverBlue cursorPointer">{val?.file_name?.split("/")[val?.file_name?.split("/").length - 1]}</p>
                                                                            }
                                                                        </td>
                                                                        <td>{val?.remarks}</td>
                                                                        { decodedData?.includes(4) && ( 
                                                                            <td className=' text-center'>
                                                                                {loadingDelete === val?.id ?
                                                                                    <button
                                                                                        type="button" class="btn btn-danger bg-danger text-light F "
                                                                                    >Loading...</button> :
                                                                                    <button
                                                                                        onClick={() => { handleDeleteExcel(val?.id) }} type="button" class="btn btn-danger bg-danger text-light waves-effect "
                                                                                    >Delete</button>
                                                                                }
                                                                            </td>)
                                                                        }
                                                                    </tr>
                                                                )
                                                            })

                                                            }

                                                        </>
                                                        :
                                                        <td colSpan={5}>
                                                            <NoRecords />
                                                        </td>
                                                    }


                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className="d-flex bg-light justify-content-between align-items-center w-100 py-2 px-2" >
                                    <button disabled={!pagination?.prev} type="button" onClick={() => handlePrev()} className={`btn btn-warning btn-label waves-effect waves-light`}><i className="ri-arrow-left-line label-icon align-middle fs-16 me-2" /> Previous</button>
                                    <div className='col-md-4' style={{ display: 'flex', alignItems: 'center' }}>
                                        {
                                            <small>Total Records: {pagination?.total_records} | Total Pages: {pagination?.total_pages} | Current Page: {pagination?.page}</small>
                                        }
                                    </div>
                                    <div className='col-md-2'>
                                        <select className="form-select" onChange={(e) => handleChanged(e)}>
                                            {Array.from({ length: pagination?.total_pages }, (_, i) => (
                                                <option selected={pagination?.page === i + 1} key={i} value={i + 1}>Page {i + 1}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-2">
                                        <select className="form-select" onChange={(e) => handleLimitChange(e)} value={pagination?.limit}>
                                            {pagination?.total_records >= 1 && (
                                                <option value={pagination?.total_records}>
                                                    All
                                                </option>
                                            )}
                                            {limitOptions?.map((option) => (
                                                <option key={option} value={option}>
                                                    Limit {option}
                                                </option>
                                            ))}
                                            
                                        </select>
                                    </div>
                                    <button disabled={!pagination?.next} type="button" onClick={() => handleNext()} className={`btn btn-primary btn-label waves-effect right waves-light`}><i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2" /> Next</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> :
                <div className='d-flex justify-content-center align-items-center' style={{ height: "90vh" }}>
                    <div className="text-center">
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                </div>

            }
        </section >
    );
}

export default PayrollOtherHeadImport;

